import { render, staticRenderFns } from "./PacketCheckError.vue?vue&type=template&id=55db06ac&scoped=true"
import script from "./PacketCheckError.vue?vue&type=script&lang=js"
export * from "./PacketCheckError.vue?vue&type=script&lang=js"
import style0 from "./PacketCheckError.vue?vue&type=style&index=0&id=55db06ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55db06ac",
  null
  
)

export default component.exports